
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1729478038213",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "3078",
    "width": "16",
    "height": "16"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M544 896l64 0 0 64-64 0 0-64Z",
        "fill": "#272636",
        "p-id": "3079"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M416 416 416 64 64 64l0 352 64 0 0 64 64 0 0-64L416 416zM128 352 128 128l224 0 0 224L128 352z",
        "fill": "#272636",
        "p-id": "3080"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M192 192l96 0 0 96-96 0 0-96Z",
        "fill": "#272636",
        "p-id": "3081"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M608 64l0 352 352 0L960 64 608 64zM896 352l-224 0L672 128l224 0L896 352z",
        "fill": "#272636",
        "p-id": "3082"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M736 192l96 0 0 96-96 0 0-96Z",
        "fill": "#272636",
        "p-id": "3083"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M192 736l96 0 0 96-96 0 0-96Z",
        "fill": "#272636",
        "p-id": "3084"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M64 480l64 0 0 64-64 0 0-64Z",
        "fill": "#272636",
        "p-id": "3085"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M192 480l64 0 0 64-64 0 0-64Z",
        "fill": "#272636",
        "p-id": "3086"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M256 608 64 608l0 352 352 0L416 608l-96 0 0-64L256 544 256 608zM352 672l0 224L128 896l0-224L352 672z",
        "fill": "#272636",
        "p-id": "3087"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M480 96l64 0 0 96-64 0 0-96Z",
        "fill": "#272636",
        "p-id": "3088"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M480 256l64 0 0 64-64 0 0-64Z",
        "fill": "#272636",
        "p-id": "3089"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M672 480 608 480 544 480 544 384 480 384 480 480 320 480 320 544 480 544 544 544 608 544 608 608 672 608 672 544Z",
        "fill": "#272636",
        "p-id": "3090"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M672 608l64 0 0 64-64 0 0-64Z",
        "fill": "#272636",
        "p-id": "3091"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M480 608l64 0 0 96-64 0 0-96Z",
        "fill": "#272636",
        "p-id": "3092"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M480 768l64 0 0 128-64 0 0-128Z",
        "fill": "#272636",
        "p-id": "3093"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M608 704l64 0 0 192-64 0 0-192Z",
        "fill": "#272636",
        "p-id": "3094"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M800 608l160 0 0 64-160 0 0-64Z",
        "fill": "#272636",
        "p-id": "3095"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M896 480l64 0 0 64-64 0 0-64Z",
        "fill": "#272636",
        "p-id": "3096"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M736 480l128 0 0 64-128 0 0-64Z",
        "fill": "#272636",
        "p-id": "3097"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M736 704l64 0 0 64-64 0 0-64Z",
        "fill": "#272636",
        "p-id": "3098"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M896 768 864 768 864 832 928 832 928 768 960 768 960 704 896 704Z",
        "fill": "#272636",
        "p-id": "3099"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M736 832l64 0 0 64-64 0 0-64Z",
        "fill": "#272636",
        "p-id": "3100"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M800 896l160 0 0 64-160 0 0-64Z",
        "fill": "#272636",
        "p-id": "3101"
      }
    }
  ]
})
    }
  